import User from "./user";

const getUserOrganizationNameList = (user: User) => {
  const organizationNames = [];

  for (const userGroup of user.userGroups) {
    for (const organization of userGroup.organizations) {
      organizationNames.push(organization.organizationName);
    }
  }

  return organizationNames.sort();
};

const getUserOrganizationNames = (user: User) => {
  const organizationNames = getUserOrganizationNameList(user);
  const names = organizationNames.join(", ");
  return names;
};

const userManager = {
  getUserOrganizationNameList,
  getUserOrganizationNames,
};

export default userManager;
